import React from "react";
import PropTypes from "prop-types";

function PromoterProfileResult({ gid }) {
  return <div>PromoterProfile: {JSON.stringify(gid)}</div>;
}

PromoterProfileResult.propTypes = {
  gid: PropTypes.string.isRequired,
};
export default PromoterProfileResult;
